import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import SectionContainer from 'modules/core/components/SectionContainer'

import Sidebar from 'modules/bookkeepers/components/Sidebar'
import { IncidenceMessageStatsProvider } from 'modules/bookkeepers/hooks/IncidenceMessageStatsContext'
import { IncidenceStatsProvider } from 'modules/bookkeepers/hooks/IncidenceStatsContext'
import useGetIncidenceStats from 'modules/bookkeepers/hooks/useGetIncidenceStats'

const Content = ({ children }: React.PropsWithChildren<unknown>) => {
  const { incidenceStats, incidenceMessageStats } = useGetIncidenceStats()

  return (
    <IncidenceStatsProvider value={incidenceStats}>
      <IncidenceMessageStatsProvider value={incidenceMessageStats}>
        <Box
          width="full"
          background="grey000White"
          flexDirection="row"
          style={{ height: '100vh', overflowY: 'auto' }}
        >
          <Sidebar />
          <Box width="full">
            <SectionContainer>{children}</SectionContainer>
          </Box>
        </Box>
      </IncidenceMessageStatsProvider>
    </IncidenceStatsProvider>
  )
}

export default Content
